import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { Business } from '../../../types/business.type';
import Business_default_logo from '../../../assets/images/icon_business.svg';
import CrossIcon from '../../common/Icons/CrossIcon';
import { getCustomerName } from '../../../customer-call-sdk/context/CallContext/CallProvider';

const StyledBusinessDetail = styled.div`
    bottom: 0px;
    position: absolute;
    width: 100%;
    z-index: 999;
    height: 90%;
    background-color: white;
    border-radius: 15px;
    .close-icon-box {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding-right: 20px;
        margin-top: 15px;
    }
    .cross-icon {
        width: 30px;
        height: 30px;
        cursor: pointer;
    }

    .img-content {
        margin-left: 20px;
        margin-top: 30px;
    }
    .bussiness-icon {
        max-height: 70px;
        max-width: 70px;
    }
    .business-detail-content {
        margin-top: 20px;
    }
    .business-detail-box {
        border-top: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        max-height: 150px;
        line-height: 20px;
        padding-left: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        overflow: auto;
    }
    .business-name {
        font-weight: 700;
        font-size: 30px;
        color: black;
        padding-left: 20px;
    }
    .category-tags {
        color: #7e7c7f;
        font-size: 12px;
        text-transform: uppercase;
        font-weight: bold;
    }
    .business-description {
        margin-top: 10px;
        font-size: 23px;
        line-height: 30px;
    }

    .business-type {
        font-weight: 700;
        font-size: 20px;
        color: black;
        margin-top: 10px;
        padding-left: 20px;
    }
    .driver {
        border: 0.7px solid #e8e8e8;
    }
    .call-button {
        width: 80%;
        background-color: #408f50;
        border-radius: 300px;
        color: white;
        line-height: 40px;
        text-align: center;
        margin-top: 1rem;
    }
    .button-area {
        width: 100%;
        position: absolute;
        bottom: 30px;
    }

    .button-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
interface BusinessDetailProps {
    business: Business;
    closeBusinessDetail: () => void;
    handleCallClick: (number: string) => void;
}
const BusinessDetail = ({
    business,
    closeBusinessDetail,
    handleCallClick,
}: BusinessDetailProps) => {
    const dispatch = useDispatch();
    const handleOnCustomerClick = (businessData: Business) => {
        dispatch(getCustomerName(businessData.businessName));
        handleCallClick(businessData.number);
    };

    return (
        <StyledBusinessDetail>
            <div className="close-icon-box" onClick={closeBusinessDetail}>
                <CrossIcon className="cross-icon" />
            </div>

            <div className="img-content">
                <img
                    className="bussiness-icon"
                    src={business.photoURL ? business.photoURL : Business_default_logo}
                    alt=""
                />
            </div>
            <div className="business-detail-content">
                <div className="business-name">{business.businessName}</div>
                <div className="business-detail-box">
                    <div className="category-tags">
                        {business.categoryName ? business.categoryName : business.categoryTags}
                    </div>
                    <div className="business-description">{business.description}</div>
                </div>
                <div className="business-type">{business.businessType}</div>
            </div>
            <div className="button-area">
                <div className="driver" />
                <div className="button-box">
                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        className="call-button"
                        onClick={() => {
                            handleOnCustomerClick(business);
                        }}
                        aria-label="Call"
                    >
                        call
                    </Button>
                </div>
            </div>
        </StyledBusinessDetail>
    );
};

export default BusinessDetail;
